import axios from 'axios'
import authHeader from './auth-header'

const baseUrl = `${process.env.VUE_APP_API_URL}engineering-copilot`

class EngineeringCopilotService {
  tickets (params = {}) {
    return axios.get(`${baseUrl}/tickets`, { headers: authHeader(), params })
  }

  ticket (id) {
    return axios.get(`${baseUrl}/tickets/${id}`, { headers: authHeader() })
  }

  sync () {
    return axios.post(`${baseUrl}/tickets/sync`, {}, { headers: authHeader() })
  }

  analyze (ticketId, projectId) {
    return axios.post(`${baseUrl}/tickets/${ticketId}/analyze`, { project_id: projectId || null }, { headers: authHeader() })
  }

  guidance (ticketId, body, projectId) {
    return axios.post(`${baseUrl}/tickets/${ticketId}/guidance`, {
      body,
      project_id: projectId || null,
      reanalyze: true,
    }, { headers: authHeader() })
  }

  approveExecution (runId) {
    return axios.post(`${baseUrl}/runs/${runId}/approve`, { target: 'execute' }, { headers: authHeader() })
  }

  prepareResponse (runId) {
    return axios.post(`${baseUrl}/runs/${runId}/approve`, { target: 'response' }, { headers: authHeader() })
  }

  approvePublication (runId, options) {
    return axios.post(`${baseUrl}/runs/${runId}/approve`, {
      target: 'publish',
      ...options,
    }, { headers: authHeader() })
  }

  reject (runId, feedback) {
    return axios.post(`${baseUrl}/runs/${runId}/reject`, { feedback }, { headers: authHeader() })
  }

  knowledge (params = {}) {
    return axios.get(`${baseUrl}/knowledge`, { headers: authHeader(), params })
  }

  updateKnowledge (id, data) {
    return axios.put(`${baseUrl}/knowledge/${id}`, data, { headers: authHeader() })
  }
}

export default new EngineeringCopilotService()
